import css from '../tpl-css/style-section-grid-item-kynorelle-05.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  data-id="unique-id"
  data-background="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
  data-color="#000000"
  style="background-color: #ffffff; color: #000000; --text-color: #000000;"
>
  <div data-attribute="container" class="container">
    <div class="wrap-card">
      <div data-show="false" data-attribute="title-card" class="title-card" style="display: none;"></div>
      <div class="layout-body">
        <div class="group-heading">
          <div class="left-img">
            <img
              data-attribute="image-heading"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0eb45841c2f2564e964c0.png"
              alt=""
            />
          </div>
          <div class="right-content">
            <div data-attribute="text-heading" class="text-heading">
              <h2>
                <span style="color:hsl(209,100%,20%);">REASON WHY KYNORELLE ISN'T LIKE</span><br /><span
                  style="color:hsl(209,100%,20%);"
                  >ANY YOU'VE WORN BEFORE</span
                >
              </h2>
            </div>
            <div data-show="true" data-attribute="highlight-text" class="highlight-text" style="display: block;">
              Leggings that feel tight slip and need constant adjusting.
            </div>
          </div>
        </div>
        <div class="group-content">
          <div class="left-img">
            <img
              data-attribute="image-content"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0eb4bfe7f107382536b40.png"
              alt=""
            />
          </div>
          <div class="right-content">
            <div data-attribute="text-content" class="text-content">
              <ul>
                <li>Most only work for a while.</li>
                <li>Kynorelle is made for the whole day.</li>
                <li>No rolling, No pressure, No adjusting</li>
                <li>Just all-day comfort</li>
              </ul>
            </div>
            <a
              data-attribute="button-link"
              data-background="#003568"
              data-color="#ffffff"
              data-show="true"
              href="#"
              style="--button-background-color: #003568; --button-text-color: #ffffff; display: inline-flex;"
              class="btn-shop-now"
            >
              <span>SHOP NOW</span>
              <span class="icon">
                <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L3.2175 4.3875L0 8.775H2.145L5.3625 4.3875L2.145 0H0Z" fill="currentColor"></path>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
